import { useLocation } from "react-router-dom";
import Fetch from "../Fetch";
import UserList from "./UserList";
import { URL, TYPE, ACTION } from "../URL";
import { get_sort_flags } from "../util";

export default function FetchUserList() {
    const flags = get_sort_flags(useLocation());
    return (
        <Fetch
            url={new URL(ACTION.LIST, TYPE.USER, 0, flags)}
            renderSuccess={(data) => <UserList data={data.data} />}
        />
    );
}
